const FALLBACK_SESSION_MS = 24 * 60 * 60 * 1000;

type StoredSession = { accessToken?: string; loginTime?: number };

const readSession = (): StoredSession | null => {
  try {
    return JSON.parse(localStorage.getItem("userDetails") || "null");
  } catch {
    return null;
  }
};

const getJwtExpiryMs = (token?: string): number | null => {
  if (!token) return null;
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const decoded = JSON.parse(atob(normalized));
    return typeof decoded.exp === "number" ? decoded.exp * 1000 : null;
  } catch {
    return null;
  }
};

export const getSessionExpiryMs = (): number | null => {
  const session = readSession();
  if (!session?.accessToken) return null;
  return getJwtExpiryMs(session.accessToken) || (session.loginTime || Date.now()) + FALLBACK_SESSION_MS;
};

export const isSessionExpired = () => {
  const expiry = getSessionExpiryMs();
  return !expiry || Date.now() >= expiry;
};

export const hasActiveSession = () => !isSessionExpired();

export const endSession = () => {
  localStorage.removeItem("userDetails");
  if (window.location.pathname !== "/login") window.location.replace("/login");
};

